import { gql } from '@apollo/client'

export const Query = gql`
  query EditEvent($companyId: ID!, $filters: EventFilters) {
    events(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        description
        details
        warehouse { id }
        state
        dateOut
        dateStart
        dateEnd
        dateReturn
        client { id }
        venue { id }
        portfolioPage { id }
      }
    }
  }
`
